import{jsx as n}from"react/jsx-runtime";import{styled as o}from"styled-components";const e=o.div`
  display: flex;
  justify-content: ${n=>"left"===n.$position?"flex-start":"flex-end"};
  margin: 0 4px;
`,r=o.button`
  ${n=>n.disabled?"\n  border: 1px solid #cccccc;\n  background-image: url(images/button_disable.png);\n":"\n  cursor: pointer;\n  border: 1px solid #a3a3a3;\n  background-image: url(images/button.png);\n\n  &:hover {\n    border: 1px solid #cccccc;\n    background: url(images/button_hover.png);\n  };\n"}
  border-radius: 10px;
  min-width: 99px;
  height: 24px;
  white-space: nowrap;
  box-shadow: 1px 1px 2px #888888;
  font-family: Consolas, monospace;
`;function i({label:o,position:i="left",...t}){return n(e,{$position:i,children:n(r,{...t,children:o})})}export{i as Button};
